const ROLE_SUPER_ADMIN = 'super_admin';
const ROLE_ADMIN = 'admin';
const ROLE_VIEWER = 'viewer';

const ROLE_PERMISSIONS = {
  admins: { view: [ROLE_SUPER_ADMIN], create: [ROLE_SUPER_ADMIN], update: [ROLE_SUPER_ADMIN], delete: [ROLE_SUPER_ADMIN] },
  players: { view: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_VIEWER], create: [ROLE_SUPER_ADMIN, ROLE_ADMIN], update: [ROLE_SUPER_ADMIN, ROLE_ADMIN], delete: [ROLE_SUPER_ADMIN, ROLE_ADMIN] },
  tournaments: { view: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_VIEWER], create: [ROLE_SUPER_ADMIN, ROLE_ADMIN], update: [ROLE_SUPER_ADMIN, ROLE_ADMIN], delete: [ROLE_SUPER_ADMIN, ROLE_ADMIN] },
  teams: { view: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_VIEWER], create: [ROLE_SUPER_ADMIN, ROLE_ADMIN], update: [ROLE_SUPER_ADMIN, ROLE_ADMIN], delete: [ROLE_SUPER_ADMIN, ROLE_ADMIN] },
  schedules: { view: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_VIEWER], create: [ROLE_SUPER_ADMIN, ROLE_ADMIN], update: [ROLE_SUPER_ADMIN, ROLE_ADMIN], delete: [ROLE_SUPER_ADMIN, ROLE_ADMIN] },
  registrations: { view: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_VIEWER], create: [ROLE_SUPER_ADMIN, ROLE_ADMIN], update: [ROLE_SUPER_ADMIN, ROLE_ADMIN], delete: [ROLE_SUPER_ADMIN, ROLE_ADMIN], verify: [ROLE_SUPER_ADMIN, ROLE_ADMIN] },
  audit_logs: { view: [ROLE_SUPER_ADMIN] },
  competition_systems: { view: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_VIEWER], create: [ROLE_SUPER_ADMIN], update: [ROLE_SUPER_ADMIN], delete: [ROLE_SUPER_ADMIN] },
};

function getAdminFromStorage() {
  try {
    const raw = localStorage.getItem('admin');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function useAuth() {
  const admin = getAdminFromStorage();
  const role = admin.role || ROLE_ADMIN;
  const customPerms = admin.permissions || [];

  const hasPermission = (resource, action) => {
    const permKey = `${resource}:${action}`;
    if (customPerms.length > 0) {
      return customPerms.includes(permKey);
    }
    const allowed = ROLE_PERMISSIONS[resource]?.[action] || [];
    return allowed.includes(role);
  };

  return {
    admin,
    role,
    permissions: customPerms,
    isSuperAdmin: role === ROLE_SUPER_ADMIN,
    canCreate: (resource) => hasPermission(resource, 'create'),
    canUpdate: (resource) => hasPermission(resource, 'update'),
    canDelete: (resource) => hasPermission(resource, 'delete'),
    canView: (resource) => hasPermission(resource, 'view'),
    canViewAdmins: () => hasPermission('admins', 'view'),
    canViewAuditLogs: () => hasPermission('audit_logs', 'view'),
    canViewCompetitionSystems: () => hasPermission('competition_systems', 'view'),
    canVerify: () => hasPermission('registrations', 'verify'),
  };
}
